import React, { lazy, useContext } from "react";
import InstallationDetailsTable from "./InstallationDetailsTable";
import { Breadcrumbs, BreadcrumbItem } from "@vds/breadcrumbs";
import { Spacer } from "../../../components/core/utility";
import backArrowIcon from "../../../assets/icons/back-arrow-icon.png";
import { redirectToPrevPage } from "../../C4S Decommission - Replacement/utils";
import "../ViewVehicleDetailsComponent.css";
import "./installationDetails.css";
import { PrivilegeContext } from "../../../../context/privilegeContext";
import moment from "moment";

const InstallationDetails = ({ summaryData }) => {
  const { date, time, poweredAssets, totalDuration, calculatedDuration } = summaryData || {};
  const { cspInfo } = useContext(PrivilegeContext);

  const handleBack = () => {
    redirectToPrevPage();
  };

  return (
    <div className="installation-details-page">
      <Spacer top="10px" />

      {/* Breadcrumb */}
      {/* <Breadcrumbs surface="light">
        <BreadcrumbItem active={false}>
          <span className="breadcrumbLink" onClick={handleBack}>
            Schedule Installation
          </span>
        </BreadcrumbItem>
        <BreadcrumbItem active={true}>
          <span className="breadcrumbTitle">Installation details</span>
        </BreadcrumbItem>
      </Breadcrumbs> */}

      {/* Order header */}
      <div className="id-order-header">
        <div className="id-order-number">Order #{cspInfo.data.data.CSP[0].Provider_Order}</div>
        <div className="id-opportunity-created">
          Opportunity Created: {moment(cspInfo.data.data.CSP[0].OppCreatedDateTime).format("MMMM D, YYYY")}
        </div>
      </div>

      {/* Header row */}
      <div className="pageWrapper ">
        <div className="headerRow ">
          <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
            <button type="button" onClick={handleBack} className="backBtn" aria-label="Back">
              <img src={backArrowIcon} alt="" aria-hidden="true" className="backIcon" />
            </button>
            <span className="id-page-title">Installation Details</span>
          </div>
          <div className="id-duration">
            <span className="id-duration-label">Estimated total duration: &nbsp;</span>
            <span className="id-duration-value">{calculatedDuration}</span>
          </div>
        </div>

        <Spacer top="20px" />

        <div className="welcome-banner">{/* <InstallationDetailsTable /> */}</div>
      </div>
    </div>
  );
};

export default InstallationDetails;

export const InstallationDetailsMetadata = {
  name: "Installation Details",
  id: "installation_details",
  component: lazy(() => import("./InstallationDetails")),
  route: "/installation_details",
};
